import { t } from './ProductPriceCart-8f498506.js';
export { G as Gift, N as NAMESPACE, P as ProductInfo, a as ProductPriceCart, i as PromoItemType, f as formatPrice, b as formatPriceFull, j as getBenefits, h as getBlockDescriptionForCartPromo, c as getComboImageUrl, g as getComboName, d as getDateStringWithFormat, e as getDateStringsTimeRange, k as getPromotionProduct, m as getVoucherBenefit, l as lang } from './ProductPriceCart-8f498506.js';
import { styled, Body, useTheme, Tag, SubTitle, Caption } from '@teko/ds-desktop';
import React, { useState, useEffect } from 'react';
import { Input } from '@teko/ecommerce/mobile';
import { ModalBody } from '@teko/ds-foundation';
import { formatCurrency } from '@teko/teko-ecommerce';
import 'date-fns/format';
import 'tslib';
import 'react-popper';
import 'i18next';
import '@teko/ds-icon';

const Container = styled.div(({ forMobile, theme }) => `
  display: flex;
  border-radius: 0.5rem;
  align-items: stretch;
  ${!forMobile ? `border: 1px solid ${theme.colors.divider}` : ''}
`);
const Left = styled.div(({ theme, highlighted, forMobile }) => `
  flex: 1 1 auto;
  background-color: ${highlighted ? theme.colors.primary50 : theme.colors.white};
  border-radius: ${forMobile ? '0.5rem' : '0.5rem 0 0 0.5rem'};
  position: relative;
  box-shadow: ${forMobile ? 'rgba(0, 0, 0, 0.05) 0px 2px 4px 0px' : 'none'};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  > div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &:before {
    content: '';
    position: absolute;
    height: 75%;
    width: 0;
    border: 1px dashed #e4e5f0;
    right: -1px;
    top: 50%;
    transform: translateY(-50%);
  }
`);
const Right = styled.div(({ theme, highlighted, forMobile }) => `
  flex: 0 0 5rem;
  background-color: ${highlighted ? theme.colors.primary50 : theme.colors.white};
  border-radius: ${forMobile ? '0.5rem' : '0 0.5rem 0.5rem 0'};
  position: relative;
  box-shadow: ${forMobile ? 'rgba(0, 0, 0, 0.05) 0px 2px 4px 0px' : 'none'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    height: 75%;
    width: 0;
    border: 1px dashed #e4e5f0;
    left: -1px;
    top: 50%;
    transform: translateY(-50%);
  }
`);
const Divider = styled.div `
  height: 0.5rem;
  border-right: 1px solid #e4e5f0;
`;
const RightAction = styled(Body) `
  cursor: pointer;
  user-select: none;
`;
const VoucherBlock = ({ applied = false, inappliable = false, onApply, voucher: { type, code, benefit, seller, endedAt }, forMobile = false, }) => {
    const theme = useTheme();
    const endedDate = !!Date.parse(endedAt) && new Date(endedAt);
    const endedDateString = endedDate
        ? `${endedDate.getDate()}/${endedDate.getMonth() + 1}/${endedDate.getFullYear()}`
        : '';
    return (React.createElement(Container, { forMobile: forMobile },
        React.createElement(Left, { forMobile: forMobile, highlighted: applied },
            React.createElement("div", null,
                !!type && React.createElement(Tag, { content: type, type: "secondary", variant: "link" }),
                React.createElement(Tag, { content: code, type: "ghost" })),
            forMobile ? (React.createElement(SubTitle, { level: 2, weight: "medium" }, benefit)) : (React.createElement(Body, { level: 2, weight: "medium" }, benefit)),
            React.createElement("div", null,
                !!seller && (React.createElement(Caption, { color: theme.colors.textSecondary, level: 3, weight: "medium" }, seller)),
                !!seller && !!endedDate && React.createElement(Divider, null),
                !!endedDate && (React.createElement(Caption, { color: theme.colors.textSecondary, level: 3, weight: "medium" }, `HSD: ${endedDateString}`)))),
        React.createElement(Right, { forMobile: forMobile, highlighted: applied },
            React.createElement(RightAction, { level: 1, weight: "regular", color: inappliable ? theme.colors.disable : theme.colors.link500, onClick: onApply }, applied ? t('Dùng sau') : t('Áp dụng')))));
};

const StyledInput = styled(Input) `
  border-radius: 4px;
  background-color: #ffffff;
  margin-bottom: 0.5em;
`;
const StyledModalBoday = styled(ModalBody) `
  padding: 0;
`;
const StyledNotiText = styled.div `
  color: #82869e;
  font-size: 0.8125rem;
`;
const Row = styled.div(({ mb }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${mb || 0};
  `);
const StyledText = styled.span(({ color }) => `
  font-size: 0.8125rem;
  line-height: 1.5rem;
  font-weight: 500;
  color: ${color || '#434657'}`);
const defaultWarningText = (maxConsultationServiceFee, sellingPrice) => {
    return (React.createElement(StyledNotiText, null,
        t('Được phép nâng giá bán tối đa'),
        ' ',
        formatCurrency(maxConsultationServiceFee + sellingPrice)));
};
const getStyledCurrency = (amount) => {
    const formatedCurrency = formatCurrency(amount);
    return amount >= 0 ? (React.createElement(StyledText, { color: "#2BB956" }, `+${formatedCurrency}`)) : (React.createElement(StyledText, { color: "#E6983A" }, `${formatedCurrency}`));
};
const ConsultationServiceFee = ({ maxConsultationServiceFee, sellingPrice, isShow = true, onChangePrice, defaultExpectedPrice, }) => {
    const initialWarningText = t('Giá muốn bán không được vượt quá {{var0}}', {
        var0: formatCurrency(maxConsultationServiceFee + sellingPrice),
    });
    const [showWarning, setShowWarning] = useState(false);
    const [changeAmount, setChangeAmount] = useState(0);
    const [warningText, setWarningText] = useState(initialWarningText);
    const handlePriceChange = (e) => {
        const expectedPrice = e.target.value;
        if (!!expectedPrice && expectedPrice < sellingPrice) {
            setShowWarning(true);
            setWarningText(t('Giá muốn bán không được nhỏ hơn giá sản phẩm'));
        }
        else if ((!!expectedPrice &&
            expectedPrice <= maxConsultationServiceFee + sellingPrice) ||
            !expectedPrice) {
            setShowWarning(false);
        }
        else if (expectedPrice > maxConsultationServiceFee + sellingPrice) {
            setShowWarning(true);
            setWarningText(initialWarningText);
        }
        setExpectedPrice(e.target.value);
        setChangeAmount(e.target.value - sellingPrice);
        if (onChangePrice)
            onChangePrice(e);
    };
    const [expectedPrice, setExpectedPrice] = useState(defaultExpectedPrice);
    useEffect(() => {
        setExpectedPrice(defaultExpectedPrice);
        setChangeAmount(defaultExpectedPrice - sellingPrice);
    }, [sellingPrice, defaultExpectedPrice]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledModalBoday, null,
            React.createElement(Row, { mb: "0.5rem" },
                React.createElement(StyledText, null, t('Giá sản phẩm')),
                React.createElement(StyledText, null, formatCurrency(sellingPrice))),
            React.createElement(Row, { mb: "0.25rem" },
                React.createElement(StyledText, null, t('Giá muốn bán'))),
            React.createElement(StyledInput, { placeholder: t('Nhập số tiền'), onChange: handlePriceChange, value: expectedPrice, isFocused: isShow, inputType: "price", pattern: "\\d*", inputMode: "numeric", required: true, currency: t('đ'), error: !!showWarning && warningText, allowClear: false }),
            !showWarning && (React.createElement(Row, { mb: "0.5rem" }, defaultWarningText(maxConsultationServiceFee || 0, sellingPrice || 0))),
            React.createElement(Row, { mb: "0.5rem" },
                React.createElement(StyledText, null, t('Số tiền chênh:')),
                React.createElement(StyledText, null, getStyledCurrency(changeAmount))))));
};

const empty = {};

export { ConsultationServiceFee, VoucherBlock, empty };
